<template>
    <thead>
        <th v-for="(header, i) in headers.props.headers" :key="i" style="height:0px;margin-top: -30px;">
            <div v-if="header.iconIsNedded">
                <v-icon class="icone" size="18" color="primary" @mouseleave="header.opacity = 0"
                        @mouseenter="header.opacity = 1">
                    mdi-help-box
                </v-icon>
                <div class="texto v-card"
                     :style="{ opacity: header.opacity ? header.opacity : 0, zIndex: header.opacity ? header.opacity : 0 }">
                    <!-- Para cada item no array se cria um parágrafo -->
                    <span v-for="(text, i ) in header.infoList" :key="i">{{ text }}</span>
                </div>
            </div>
        </th>
    </thead>
</template>

<script>
  export default {
    name: 'DataListHeaderWithIcons',
    props: {
      headers: { type: Object, required: true }
    },
    data: function () {
      return ({
        opacity: 0
      })
    }
  }
</script>

<style  scoped lang="scss">
th {
  position: relative;
  color: transparent;
}

.icone {
  position: absolute;
  top: 1.07rem;
  left: 19.02rem;
  right: 0;
}

.texto {
  position: absolute;
  margin-top: 32px;
  left: 0;
  top: 100%;
  padding: 12px;
  background-color: #eee;
  color: #666;
  z-index: 2;
}

.icone:hover {
  cursor: pointer;
}

@media (max-width: 1380px) {
    .icone {
        position: absolute;
        top: 1.07rem;
        left: 13rem;
        right: 0;
    }
}
</style>
